<!-- WEXHUB: override de componente upstream -->
<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store.js';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  to: { type: [Object, String], default: '' },
  label: { type: String, default: '' },
  icon: { type: [String, Object], default: '' },
  expandable: { type: Boolean, default: false },
  isExpanded: { type: Boolean, default: false },
  isActive: { type: Boolean, default: false },
  hasActiveChild: { type: Boolean, default: false },
  getterKeys: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['toggle']);

const showBadge = useMapGetter(props.getterKeys.badge);
const dynamicCount = useMapGetter(props.getterKeys.count);
const count = computed(() =>
  dynamicCount.value > 99 ? '99+' : dynamicCount.value
);
</script>

<template>
  <component
    :is="to ? 'router-link' : 'div'"
    class="flex items-center gap-3 px-2 py-2 rounded-lg h-9 min-w-0"
    role="button"
    draggable="false"
    :to="to"
    :title="label"
    :class="{
      'text-n-sidebar-item-active-accent bg-n-sidebar-item-active-bg font-medium':
        isActive && !hasActiveChild,
      'text-n-sidebar-item-active-accent font-medium': hasActiveChild,
      'text-n-sidebar-text hover:bg-n-sidebar-item-active-bg/50':
        !isActive && !hasActiveChild,
    }"
    @click.stop="emit('toggle')"
  >
    <div v-if="icon" class="relative flex items-center gap-2">
      <Icon v-if="icon" :icon="icon" class="size-5" />
      <span
        v-if="showBadge"
        class="size-2 -top-px ltr:-right-px rtl:-left-px bg-n-brand absolute rounded-full border border-n-solid-2"
      />
    </div>
    <div class="flex items-center gap-2 flex-grow min-w-0 flex-1">
      <span
        class="truncate"
        :class="{
          'text-body-main': !isActive,
          'font-medium text-sm': isActive || hasActiveChild,
        }"
      >
        {{ label }}
      </span>
      <span
        v-if="dynamicCount && !expandable"
        class="animate-fade-in-up bg-n-blue-4 capitalize flex-shrink-0 font-medium leading-5 min-w-5 outline outline-1 outline-n-sidebar-border px-1 rounded-md text-center text-n-sidebar-text-muted text-xs"
        :class="{
          'text-n-sidebar-item-active-accent outline-n-sidebar-item-active-accent/30':
            isActive,
          'text-n-sidebar-text-muted outline-n-sidebar-border': !isActive,
        }"
      >
        {{ count }}
      </span>
    </div>
    <span
      v-if="expandable"
      class="i-lucide-chevron-down size-4 flex-shrink-0 transition-transform duration-100 ease-out"
      :class="{ 'rotate-180': isExpanded }"
      @click.stop="emit('toggle')"
    />
  </component>
</template>
